import { useEffect } from 'react'
import { AlertTriangle } from 'lucide-react'
import styles from './ConfirmDestructiveModal.module.css'

type ConfirmDestructiveModalProps = {
  title:       string
  body:        string
  confirmText: string
  isPending:   boolean
  onConfirm:   () => void
  onCancel:    () => void
}

export function ConfirmDestructiveModal({
  title,
  body,
  confirmText,
  isPending,
  onConfirm,
  onCancel,
}: ConfirmDestructiveModalProps) {
  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape' && !isPending) onCancel()
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [isPending, onCancel])

  return (
    <>
      <div
        className={styles.backdrop}
        onClick={isPending ? undefined : onCancel}
        aria-hidden="true"
      />
      <div
        className={styles.dialog}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-destructive-title"
      >
        <div className={styles.header}>
          <div className={styles.iconWrap} aria-hidden="true">
            <AlertTriangle size={18} strokeWidth={2.5} />
          </div>
          <h2 id="confirm-destructive-title" className={styles.title}>{title}</h2>
        </div>

        <div className={styles.body}>
          <p className={styles.bodyText}>{body}</p>
        </div>

        <div className={styles.footer}>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={onCancel}
            disabled={isPending}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={styles.confirmBtn}
            onClick={onConfirm}
            disabled={isPending}
            autoFocus
          >
            {isPending && <span className={styles.spinner} aria-hidden="true" />}
            {isPending ? 'Executando…' : confirmText}
          </button>
        </div>
      </div>
    </>
  )
}
